<script>
import { mapGetters, mapActions } from "vuex";
export default {
  methods: {
    ...mapActions({
      logout: "user/logout"
    }),
  },
  mounted() {
    this.logout();
    this.$router.push({name: "Index"}).catch(()=>{});
  },
}
</script>